import React from 'react';
import { Attribute } from '../attributes';
import { LabelValueDisplay } from '../AttributeValue';

type ReferenceAttributePreviewProps = {
    attribute: Attribute;
};

export default function ReferenceAttributePreview({ attribute }: ReferenceAttributePreviewProps) {
    const { value, isMultiSelect } = attribute;

    const attributeValue = isMultiSelect
        ? Array.isArray(value)
            ? value.length
                ? value.map((ref) => ref?.label ?? ref).join(', ')
                : undefined
            : (value?.label ?? value)
        : value?.label;

    return attribute && <LabelValueDisplay label={attribute.label} value={attributeValue || '-'} />;
}
